import { Injectable } from '@angular/core';
import { IVersionsRepo } from '../repository/interfaces/iversions.repo';
import { Versions } from '../models/Versions';

@Injectable()
export class VersionsService {

	private static _versions: Versions;

	constructor(private versionsRepo: IVersionsRepo) {
	}

	async loadVersions(): Promise<Versions> {
		const versions = await this.versionsRepo.loadVersions();
		VersionsService._versions = versions;
		return versions;
	}

	get versions(): Versions {
		return VersionsService._versions;
	}
}
